class NewsletterForm {
  constructor(formId) {
    this.form = document.getElementById(formId);
    this.isSubmitting = false;
    this._listenerAttached = false;
    if (!this.form) return;
    this.cacheSelectors();
    this.setEventListeners();
  }

  cacheSelectors() {
    this.submitBtn = this.form.querySelector(".newsletter-submit");
    this.submitText = this.submitBtn.querySelector(".submit-text");
    this.loadingSpinner = this.submitBtn.querySelector(".loading-spinner");
    this.emailInput = this.form.querySelector("#newsletter-email");
    this.emailError = this.form.querySelector(".newsletter-error");
    this.thankYouMessage = this.form.querySelector(".thank-you-message");
  }

  setEventListeners() {
    if (!this.form || this._listenerAttached) return;
    this._listenerAttached = true;

    this.form.addEventListener(
      "submit",
      (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!this.isSubmitting && this.checkInputs()) {
          this.submitForm();
        }
      },
      true,
    );
  }

  isEmailValid = (email) => {
    const mailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return mailRegex.test(email);
  };
  checkInputs() {
    if (!this.isEmailValid(this.emailInput.value)) {
      this.emailError.innerHTML = "Please enter a valid email address.";
      return false;
    }
    this.emailError.innerHTML = "";
    return true;
  }
  handleSubmit(event) {
    event.preventDefault();
    if (this.checkInputs()) {
      this.submitForm();
    }
  }

  submitForm() {
    if (this.isSubmitting) return;

    this.isSubmitting = true;
    this.setLoading(true);

    const formData = new FormData(this.form);
    fetch(this.form.action, {
      method: "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((res) => {
        if (res.status === 429) throw new Error("rate_limited");
        if (!res.ok) throw new Error("network_error");
        this.showThankYouMessage();
        this.form.reset();
      })
      .catch(() => {
        this.showMessage("error", "An error occurred. Please try again.");
      })
      .finally(() => {
        this.isSubmitting = false;
        setTimeout(() => {
          this.isSubmitting = false;
          this.setLoading(false);
        }, 3000); 
      });
  }

  setLoading(isLoading) {
    this.submitText.classList.toggle("hidden", isLoading);
    this.loadingSpinner.classList.toggle("hidden", !isLoading);
    this.submitBtn.disabled = isLoading;
  }

  showMessage(type, message) {
    if (type === "error") {
      this.emailError.textContent = message;
    } else if (type === "success") {
      this.showThankYouMessage();
    }
  }

  showThankYouMessage() {
    if (this.thankYouMessage) {
      this.thankYouMessage.style.display = "block";
      this.thankYouMessage.setAttribute("aria-live", "polite");
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  console.log("DOM loaded, initializing form");
  new NewsletterForm("newsletter-form");
});
